import React from "react";
import {connect} from "react-redux";
import NetworkAwareBusyOverlayCmp from "../NetworkAwareBusyOverlayCmp";
import AuctionsManager from "@nextlot/core/webcast/services/AuctionsManager";

import {CurrencyAmountDisplay} from "../CurrencyAmountDisplay";
import BidderBidHistoryCmp from "./BidderBidHistoryCmp";
import {useTranslation} from "react-i18next";
import {ReduxWebcastCurrentRoundType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRound";
import {ReduxWebcastCurrentRoundBiddingType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRoundBidding";
import {Lot} from "@nextlot/core/webcast/data/data_types_definitions";
import {RoundTypeEnum} from "@nextlot/core/webcast/data/WebcastDataDomain";
import {ReduxActiveWebcastSubStateType} from "@nextlot/core/webcast/redux/reducerActiveWebcast";
import {ChannelEnum} from "@nextlot/core/webcast/redux/actions";
import {useIsMobileDevice} from "@nextlot/core/src//hooks/useIsMobileDevice";
import SwipeButtonAnimatedCmp from "./SwipeButtonAnimatedCmp";




type RootCmpProps = {
    currentRound: ReduxWebcastCurrentRoundType,
    currentRoundBidding: ReduxWebcastCurrentRoundBiddingType,
    auctionDataLotsById: Map<number, Lot>,
};

function BidButton(props: { currentRoundBidding: ReduxWebcastCurrentRoundBiddingType, t: any }) {
    const {roundId, askingBidValue, highestBid, bidIncrement} = props.currentRoundBidding;
    const currentUserIsViewer: boolean = AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.participantRole !== 'bidder';
    const bidderCanPlaceBid: boolean = AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.bidderCanPlaceBid;
    const myUserId: number = AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.participantId;
    const {t} = props;

    const isMobileDevice = useIsMobileDevice();

    const handlePlaceBid = () => {
        AuctionsManager.currentWebcastAuctionHandler.controller.sendBidPlace(roundId, askingBidValue);
    };

    if (highestBid && highestBid.userId === myUserId) {

        return (
            <button
                type="button"
                disabled={true}
                className="w-100 p-3 btn-lg btn-bid-outline h4"
            >{t('biddingArea.youAreIn')} &nbsp; <CurrencyAmountDisplay valueCents={highestBid.value}/>
            </button>
        )
    }

    if (!askingBidValue && !highestBid) {

        return <button
            type="button"
            disabled={true}
            className="w-100 p-3 btn-lg btn-bid-outline"
        >{t('biddingArea.waitingBiddingToStart')}</button>;
    }

    if (!highestBid || (highestBid && bidIncrement)) {

        return (
          <>
          {
              bidderCanPlaceBid ?
                  isMobileDevice ?
                      <SwipeButtonAnimatedCmp
                          askingBidValue={askingBidValue}
                          handlePlaceBid={handlePlaceBid}
                        />
                      : <ClickToBidBtnCmp
                          askingBidValue={askingBidValue}
                          handlePlaceBid={handlePlaceBid}
                        />
                  : <button
                    type="button"
                    disabled={!bidderCanPlaceBid}
                    className="w-100 p-3 h4 btn-lg btn-bid"
                    >
                      {t('biddingArea.viewOnly')}
                      <CurrencyAmountDisplay valueCents={askingBidValue}/>
                    </button>
          }
          </>
        )
    }

    return <button
                type="button"
                disabled={true}
                className="w-100 p-3 btn-lg btn-bid btn-bid--outline"
            >{t('biddingArea.waitingIncrement')}</button>;
}



export function TotalBid(props: { currentRound: ReduxWebcastCurrentRoundType, currentRoundBidding: ReduxWebcastCurrentRoundBiddingType, auctionDataLotsById: Map<number, Lot>, t: any }) {
    const myUserId: number = AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.participantId;

    const {currentRound, currentRoundBidding, auctionDataLotsById, t} = props;
    const {askingBidValue, highestBid, bidIncrement} = currentRoundBidding;

    const lot = currentRound.lotsIds.map(lotId => auctionDataLotsById.get(lotId));
    const itemsQty = lot[0].itemsQty;


    if (currentRound.roundType === RoundTypeEnum.SINGLE_BOXLOT && itemsQty > 1) {
        if (highestBid && highestBid.userId === myUserId) {
            const totalBid = highestBid.value * itemsQty;

            return (
                <p className="mb-0">
                    {t('biddingArea.totalBid')}: <span className="badge bg-secondary">x {itemsQty}</span> = <CurrencyAmountDisplay valueCents={totalBid}/>
                </p>
            )
        } else {
            if (askingBidValue === 0 && bidIncrement === 0) {
                return null;
            } else {
                const totalBid = askingBidValue * itemsQty;

                return (
                    <p className="mb-0">
                        {t('biddingArea.totalBid')}: <CurrencyAmountDisplay valueCents={askingBidValue}/> x {itemsQty} = <CurrencyAmountDisplay valueCents={totalBid}/>
                    </p>
                )
            }
        }
    } else {
        return null;
    }
}

function BidderRoundBiddingCmp(props: RootCmpProps) {

    const { t, i18n } = useTranslation();
    const {currentRound, currentRoundBidding, auctionDataLotsById} = props;

    return (
        <>
            <NetworkAwareBusyOverlayCmp wbsCommChannel={ChannelEnum.bidding}/>

            <div className="mx-1 mx-xl-2 mt-2 mb-3 my-xl-3">
                <BidButton
                    currentRoundBidding={currentRoundBidding}
                    t={t}
                />
                <TotalBid
                    currentRound={currentRound}
                    currentRoundBidding={currentRoundBidding}
                    auctionDataLotsById={auctionDataLotsById}
                    t={t}
                />
            </div>


            <BidderBidHistoryCmp
                t={t}
            />

        </>
    )
}

function ClickToBidBtnCmp(props) {
  const { t, i18n } = useTranslation();
  const {handlePlaceBid, askingBidValue} = props;

  return (
    <button
      type="button"
      className="w-100 p-3 h4 btn-lg btn-bid"
      onClick={handlePlaceBid}
    >
      {`${t('biddingArea.clickToBid')}`}
      <CurrencyAmountDisplay valueCents={askingBidValue}/>
    </button>
  )
}

export default connect(({activeWebcast}: { activeWebcast: ReduxActiveWebcastSubStateType }) => {
    return {
        currentRound: activeWebcast.webcastCurrentRound,
        currentRoundBidding: activeWebcast.webcastCurrentRoundBidding,
        auctionDataLotsById: activeWebcast.webcastAuctionData.lotsMapById,
    };
})(BidderRoundBiddingCmp);
